import { createContext } from 'react';
import Document from './documentStore';
import Common from './commonStore';
import Home from './homeStore';
import Editor from './editorStore';
import Create from './createStore';

// 构建store集合
/**
 * Common 是顶层SPA的Store
 * Config 是api配置页面的Store
 * ...其他独立store需要单独添加 类似 namespace
 */
function createStores() {
  return {
    commonStore: new Common.Store(),
    documentStore: new Document.Store(),
    homeStore: new Home.Store(),
    editorStore: new Editor.Store(),
    createStore: new Create.Store(),
  };
}
const Store = createStores();

export const homeStore = Store;
export const storeContext = createContext(Store);
